"use strict";

import settings from "./settings";
import ReceiptManager from "./ReceiptManager";
import Receipt from "./Receipt";
import PrizeManager from "./PrizeManager";
import FormManager from "./FormManager";
import Common from "./Common";

$(() => {
    let $form = $("form.main");

    let RM = new ReceiptManager([], settings.selector.receipt, Receipt);
    let PM = new PrizeManager();
    let FM = new FormManager();

    // 初期レシートブロック生成

    if ($form.is("[name=entry]")) {
        // 入力画面処理

        // 初期処理
        RM.createReceiptField();
        RM.enableAppendButton();

        // Cookiesからの復元
        RM.restoreReceipt();
        // FM.restoreUserData();
        FM.restoreInquiryData();

        // 賞品選択状況の復元
        if (PM.restorePrizeFromCookies(RM.totalPrice)) {
            // 復元した場合はレシートのフォーカスによるリセットも有効化する
            RM.enableCheckReset();
        }

        // 計算するボタンの有効化
        $(settings.selector.totalPrice).find("button.calc").on("click", (e) => {
            e.preventDefault();
            // あらかじ空行を詰めておく
            RM.stuffingReceipts();
            RM.removeBlankReceipts();
            // レシート入力内容が正常時のみ金額合計チェックを行う
            if (RM.validationReceipts()) {
                PM.checkEnablePrize(RM.totalPrice);
                // フォーム要素のリセット確認も有効化する
                RM.enableCheckReset();
            } else {
                // バリデーションエラー時賞品選択を初期化する
                PrizeManager.disableAllPrize();
                PrizeManager.clearPrizeSelectable();
            }
            RM.buildErrorHTML();
        });


        // 小計/現計更新時の処理(計算するボタンの再生成)
        $(settings.selector.totalPrice).on("generate_calc_button", (e) => {
            $(settings.selector.totalPrice).find("button.calc").on("click", (e) => {
                e.preventDefault();
                // あらかじ空行を詰めておく
                RM.stuffingReceipts();
                RM.removeBlankReceipts();
                // レシート入力内容が正常時のみ金額合計チェックを行う
                if (RM.validationReceipts()) {
                    PM.checkEnablePrize(RM.totalPrice);
                    // フォーム要素のリセット確認も有効化する
                    RM.enableCheckReset();
                } else {
                    // バリデーションエラー時商品選択を初期化する
                    PrizeManager.disableAllPrize();
                    PrizeManager.clearPrizeSelectable();
                }
                RM.buildErrorHTML();
            });
        });

        // 送信ボタン処理
        $("[name=entry] .btn_entry").on("click", (e) => {
            e.preventDefault();

            // バリデーション前に詰め処理実施
            RM.stuffingReceipts();
            RM.removeBlankReceipts();

            // レシート入力内容が正常時のみ金額合計チェックを行う
            if (RM.validationReceipts()) {
                PM.checkEnablePrize(RM.totalPrice);
                RM.enableCheckReset();
                RM.buildErrorHTML();
            } else {
                RM.buildErrorHTML();
                Common.jumpBlock(settings.selector.receiptBlock);
                return false;
            }

            // 賞品の選択のチェックを行う
            if (!PrizeManager.isPrizeSelected) {
                // 選択がない場合は送信しない

                // エラー出力
                $(".prizeSelect").addClass("err");
                Common.jumpBlock("#prize-block");

                return false;
            }

            FM.saveCookies();
            $("[name=entry]:not([type=hidden])").submit();

        });

    } else if ($form.is("[name=confirm]")) {

        $(".receiptInput").each((index, elem) => {
            let $receipt = $(elem);
            let isBlank = true;
            $receipt.find("dd").each((index, block) => {
                let $block = $(block);
                let text = $block.text();
                text = text.replace(/(\s|円|\n)/g, "");

                if (text !== "") {
                    isBlank = false;
                    return false;
                }
            });
            if (isBlank) $receipt.remove();
        });

        // 確認画面の送信ボタン
        $(".btn_entry").on("click", (e) => {
            e.preventDefault();
            $form.submit();
        });
    } else if ($form.is("[name=finish]")) {
        // 完了画面処理
        FM.clearReceiptsFromCookies();
    } else {

    }

    $("form.confirm_back .btn_back").on("click", (e) => {
        $(".confirm_back").submit();
    });
});
